import React, { useEffect, useState } from "react";
import { TextField, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useNavigate, useLocation } from "react-router-dom";
import { checkUserLoggedIn } from "../shared/commonfunctions";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { sendEmialAPICall } from "../shared/APICalls";
import { ISendEmail } from "../shared/dtos";
import routesData from "../shared/routes.json";
import YourDetailsStyles from "../pages/Styles/YourDetails.module.scss";
import ContinueWithGoogle from "../Components/ContinueWithGoogle/ContinueWithGoogle";
import SnackBar from "../Components/SnackBars/SnackBar";
import firstockLogo from "../Components/assets/Images/Firstocklogo.svg";
import TagManager from "react-gtm-module";
import * as Yup from "yup";

const schema = Yup.object().shape({
  name: Yup.string()
    .required("Name is Required")
    .min(3, "Minmum 3 letters is required")
    .matches(/^[a-zA-Z ]*$/, "Enter Valid Name")
    .matches(/^(?!.*\s{2,}).*$/, "Consecutive spaces are not allowed")
    .max(50)
    .transform((value: any) => value && value.toUpperCase()),

  email: Yup.string()
    .required("Email is Required")
    .max(50, "Max 50 characters is allowed")
    .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, "Enter Valid Email"),
});

export default function YourDetails() {
  const navigate = useNavigate();

  const [emailAddress, setemailAddress] = useState<any>();
  const [message, setMessage] = useState<any>("");
  const [loading, setloading] = useState(false);

  const navigationData = routesData;

  useEffect(() => {
    window.scrollTo(0, 0);
    checkUserLoggedIn(navigate);
  }, []);

  function sendEmailAddress(emailid: any, name: any) {
    TagManager.dataLayer({
      dataLayer: {
        event: "formSubmitEmail",
        name: name,
        email: emailid,
      },
    });
    let obj: ISendEmail = {
      email: emailid,
    };
    sendEmialAPICall(obj)
      .then((response: any) => {
        sessionStorage.setItem("client-email", emailid);
        const responseData = response.data;
        // console.log(response, "response");

        setloading(false);

        if (
          responseData.data.next_stage &&
          navigationData.hasOwnProperty(responseData.data.next_stage)
        ) {
          navigate(navigationData[responseData.data.next_stage]);
        }
      })
      .catch((error: any) => {
        setloading(false);
        // console.log("error", error);

        setMessage(
          error.message.includes("Network")
            ? "Error occured, Please try again"
            : error.response.data.message,
        );
        setTimeout(() => {
          setMessage("");
        }, 5000);
      });
  }

  const callBackMessage = (data: any) => {
    setMessage(data);
  };

  function validateName(value: string) {
    let error = "";

    if (!value.trim()) {
      error = "Name Required";
    } else if (/[^a-zA-Z\s]/.test(value)) {
      error = "Extra characters not allowed";
    } else if (/\s{2,}/.test(value)) {
      error = "Consecutive spaces not allowed";
    } else if (value.length > 50) {
      error = "Max length is 50 characters";
    }

    return error;
  }

  function validateEmail(value: any) {
    let error: string = "";

    if (!value) {
      error = "Email Required";
    } else if (/\s/.test(value)) {
      error = "Email should not contain spaces";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
      error = "Invalid email address";
    } else if (value.length > 75) {
      error = "Not a valid email address";
    }

    return error;
  }

  return (
    <>
      <div className={YourDetailsStyles.wrapper}>
        <div className={YourDetailsStyles.RightContainer}>
          <div className={YourDetailsStyles.topLogoSection}>
            <img src={firstockLogo} className={YourDetailsStyles.topLogo} />
          </div>
          <div className={YourDetailsStyles.contentSection}>
            <div className={YourDetailsStyles.headerSection}>
              <p className={YourDetailsStyles.signup}>Your Details</p>
            </div>

            <Formik
              initialValues={{
                name: "",
                email: "",
              }}
              validationSchema={schema}
              onSubmit={(values) => {
                //  console.log(values);
                setloading(true);
                setemailAddress(values.email);
                sendEmailAddress(values.email, values.name);
              }}
            >
              {({
                errors,
                touched,
                handleChange,
                values,
                handleSubmit,
                handleBlur,
              }) => (
                <form
                  noValidate
                  onSubmit={handleSubmit}
                  onKeyDown={(event) => {
                    event.code === "Enter" && handleSubmit();

                    // event.code.includes("Enter") && handleSubmit()
                  }}
                  style={{ width: "100%", height: "78%" }}
                >
                  <div className={YourDetailsStyles.feildsWrapper}>
                    <div
                      style={{
                        width: "100%",
                        height: "100%",
                        marginTop: "10px",
                      }}
                    >
                      <div>
                        <TextField
                          autoComplete="off"
                          sx={{
                            fieldset: {
                              borderColor: "#E5E7EB",
                              borderRadius: "100px",
                              height: "60px",
                            },
                          }}
                          inputProps={{
                            maxLength: 50,

                            sx: {
                              "&::placeholder": {
                                fill: "#111827",
                                fontWeight: 400,
                                fontStye: "normal",
                              },
                            },
                          }}
                          className={YourDetailsStyles.textfeild}
                          name="name"
                          value={values.name}
                          error={touched.name && Boolean(errors.name)}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          id="outlined-basic"
                          label=""
                          placeholder="Full Name"
                          variant="outlined"
                          InputProps={{
                            sx: {
                              paddingLeft: "10px",
                            },
                          }}
                        />

                        <div
                          style={{
                            color: "#d32f2f",
                            fontSize: "12px",
                            height: "25px",
                            padding: "5px 0px 0px 0px",
                            textAlign: "center",
                          }}
                        >
                          {errors.name && touched.name && errors.name}
                        </div>
                      </div>
                      <div>
                        <TextField
                          autoComplete="off"
                          sx={{
                            fieldset: {
                              borderColor: "#E5E7EB",
                              borderRadius: "100px",
                              height: "60px",
                            },
                          }}
                          inputProps={{
                            maxLength: 75,
                            onKeyDown: (e) =>
                              e.key === " " && e.preventDefault(), // Prevents typing space
                            onInput: (e) =>
                              (e.currentTarget.value =
                                e.currentTarget.value.replace(/\s/g, "")),
                            sx: {
                              "&::placeholder": {
                                fill: "#111827",
                                fontWeight: 400,
                                fontStye: "normal",
                              },
                            },
                          }}
                          className={YourDetailsStyles.textfeild}
                          name="email"
                          value={values.email}
                          error={touched.email && Boolean(errors.email)}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          id="outlined-basic"
                          label=""
                          placeholder="Email"
                          variant="outlined"
                          InputProps={{
                            sx: {
                              paddingLeft: "10px",
                            },
                          }}
                        />

                        <div
                          style={{
                            color: "#d32f2f",
                            fontSize: "12px",
                            height: "25px",
                            padding: "5px 0px 0px 0px",
                            textAlign: "center",
                          }}
                        >
                          {errors.email && touched.email && errors.email}
                        </div>
                      </div>
                    </div>

                    <SnackBar message={message} />

                    <div className={YourDetailsStyles.buttonSection}>
                      {values.email && values.name ? (
                        <LoadingButton
                          variant="contained"
                          type="submit"
                          loading={loading}
                          id="yourDetailsContinueButton"
                          className={YourDetailsStyles.button}
                          onClick={() => {
                            handleSubmit();
                          }}
                        >
                          Continue
                        </LoadingButton>
                      ) : (
                        <Button
                          variant="contained"
                          disabled
                          className={YourDetailsStyles.button}
                        >
                          Continue
                        </Button>
                      )}
                      <div className={YourDetailsStyles.orSection}>
                        <span className={YourDetailsStyles.dashLine}></span> or
                        <span className={YourDetailsStyles.dashLine}></span>
                      </div>
                      <ContinueWithGoogle handleCallBack={callBackMessage} />
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
}
